import { useState } from "react";

const RENDERS = [
  {
    src: "https://customer-assets.emergentagent.com/job_trusting-ritchie-2/artifacts/jy955439_VISTA%2005.jpg",
    label: "Vista desde Vía a La Mitra y Ciudad Judicial",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_trusting-ritchie-2/artifacts/2v8mlrpp_VISTA%2001.jpg",
    label: "Vista desde el Residencial Costa Oeste",
  },
];

const Renders = () => {
  const [active, setActive] = useState(0);
  const current = RENDERS[active];

  return (
    <section
      id="renders"
      data-testid="renders-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 text-[var(--co-accent)] uppercase tracking-[0.25em] text-xs font-semibold">
              <span className="h-px w-8 bg-[var(--co-accent)]" />
              02 · Renders del proyecto
            </span>
            <h2 className="mt-6 font-display text-[var(--co-primary)] text-4xl md:text-5xl font-bold tracking-tight leading-[1.05]">
              Así se verá
              <br />
              <span className="text-[var(--co-accent)]">Costa Oeste Plaza.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-10">
            <p className="text-[var(--co-text-muted)] text-lg leading-relaxed">
              Arquitectura moderna con fachadas activas hacia la Vía a La Mitra y hacia el
              residencial Costa Oeste. Locales con doble exposición y áreas verdes integradas.
            </p>
          </div>
        </div>

        {/* Featured render */}
        <div
          data-testid="render-featured"
          className="relative w-full aspect-[16/9] bg-[var(--co-bg)] border border-[var(--co-border)] overflow-hidden"
        >
          <img
            key={current.src}
            src={current.src}
            alt={current.label}
            className="w-full h-full object-cover reveal"
            data-testid={`render-image-${active}`}
          />
          <div className="absolute bottom-4 left-4 inline-flex items-center gap-2 bg-[var(--co-primary)] text-white px-4 py-2 text-[10px] uppercase tracking-[0.25em] font-semibold">
            {current.label}
          </div>
        </div>

        {/* Thumbnails */}
        <div className="mt-4 grid grid-cols-2 gap-3">
          {RENDERS.map((r, i) => (
            <button
              key={r.src}
              data-testid={`render-thumb-${i}`}
              onClick={() => setActive(i)}
              className={`relative aspect-[16/10] overflow-hidden border-2 transition-all ${
                active === i
                  ? "border-[var(--co-accent)]"
                  : "border-transparent hover:border-[var(--co-border)]"
              }`}
            >
              <img
                src={r.src}
                alt={r.label}
                className={`w-full h-full object-cover transition-opacity ${
                  active === i ? "opacity-100" : "opacity-70 hover:opacity-100"
                }`}
              />
              <span className="absolute bottom-2 left-2 right-2 text-[10px] uppercase tracking-wider text-white font-semibold bg-[var(--co-primary)]/85 backdrop-blur-sm px-2 py-1 text-left">
                {r.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Renders;
